export default __webpack_public_path__ + "static/media/json.48fd0d35.png";